import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";

/** Line chart for data.daily (amount raised per day from 30 Sep). */
export default function DiwaliDailyChart({ data }) {
  const daily = (data?.daily || []).map((d) => ({ date: d.date.slice(5), amount: d.amount }));
  return (
    <div className="bg-amtm-surface border border-amtm-border rounded-xl p-4 mb-6" data-testid="diwali-daily-chart">
      <p className="font-semibold text-amtm-text mb-3">Daily Amount Raised</p>
      {daily.length === 0 ? (
        <p className="text-amtm-textMuted text-sm py-10 text-center" data-testid="diwali-daily-chart-empty">No data for this range yet.</p>
      ) : (
        <ResponsiveContainer width="100%" height={280}>
          <LineChart data={daily}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" fontSize={12} />
            <YAxis fontSize={12} />
            <Tooltip formatter={(v) => `₹${v.toLocaleString("en-IN")}`} />
            <Line dataKey="amount" name="Amount (₹)" stroke="#F54F1B" strokeWidth={2} dot={false} />
          </LineChart>
        </ResponsiveContainer>
      )}
    </div>
  );
}
